import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirParametroSistemaRequest } from './types';

// ACTIONS
import {
	excluirParametroSistemaSuccess,
	excluirParametroSistemaFailure,
} from './actions';

function* excluirParametroSistema(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirParametroSistemaRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`parametros-sistema/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirParametroSistemaSuccess(response));
	} else if (response.error) {
		yield put(excluirParametroSistemaFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_PARAMETRO_SISTEMA, excluirParametroSistema),
]);
